import React from 'react';
import { Heading } from '../../components';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaCat, FaDog } from 'react-icons/fa6'

const petTypeDisplayData = {
  Dog_use: {
    name: 'Dog',
    icon: <FaDog />,
  },
  cat: {
    name: 'Cat',
    icon: <FaCat />,
  },
};


const SectionPetType = props => {
  const { heading, selectedOptions = [] } = props;
  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul  className={css.petTypeList}>
        {selectedOptions.map(option => {
          const facility = petTypeDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{facility?.icon}</span>
              <span>{facility?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionPetType;
